export const ifElse = testCondition => trueCondition => falseCondition => input => (
  testCondition(input) ? trueCondition(input) : falseCondition(input)
)
export const flip = f => a => b => f(b)(a)
export const prop = prop => obj => obj[prop]
export const assoc = prop => value => obj => Object.assign({},obj,{[prop]: value})
export const pickAll = items => obj => items.reduce( (acc,item) => assoc(item)(obj[item])(acc), {} )
export const pick = items => obj => items.reduce( (acc,item) => obj[item] ? assoc(item)(obj[item])(acc) : acc, {} )
export const always = a => b => a
export const add = a => b => a + b
export const head = arr => arr[ 0 ]
export const tail = arr => arr.slice( 1 )
export const identity = a => a
export const pipe = ( ...funcs ) => input => tail( funcs ).reduce( (a,b) => b(a), head( funcs )( input ) )
export const compose = ( ...funcs ) => pipe( ...funcs.slice().reverse() )
export const times = callback => numberOfTimes => {
  let returnValues = []
  for( let index=0; index < numberOfTimes; index++ ){
    returnValues.push( callback( index ) );
  }
  return returnValues
}
export const chunk = n => arr => !arr.length 
  ? [] 
  : [ arr.slice( 0, n ) ].concat( chunk( n )( arr.slice(n) ) )

export const IdentityFunctor = x => ({
  map: f => IdentityFunctor(f(x)),
  fold: f => f(x),
  inspect: f => `IdentityFunctor(${x})`,
}) 


export const Right = x => ({
  map: f => Right(f(x)),
  fold: (l,r) => r(x),
  inspect: () => `Right(${x})`
})

export const Left = x => ({
  map: f => Left(x),
  fold: (l,r) => l(x),
  inspect: () => `Left(${x})`  
})


export const fromNullable = x => 
  x != null ? Right(x) : Left(null)




// WEBPACK FOOTER //
// ./src/functional.js